import React from 'react';
import { NavLink } from 'react-router-dom';
import { House, Users, FileText, UserCircle, UsersThree } from '@phosphor-icons/react';

export const BottomNav = () => {
  const navItems = [
    { to: '/dashboard', icon: House, label: 'Home', testId: 'nav-dashboard' },
    { to: '/leads', icon: Users, label: 'Enquiry', testId: 'nav-leads' },
    { to: '/invoices', icon: FileText, label: 'Invoices', testId: 'nav-invoices' },
    { to: '/customers', icon: UsersThree, label: 'Customer', testId: 'nav-customers' },
    { to: '/profile', icon: UserCircle, label: 'Profile', testId: 'nav-profile' },
  ];

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-[#E5E7EB] z-50" data-testid="bottom-navigation">
      <div className="grid grid-cols-5 h-16">
        {navItems.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={item.testId}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center gap-1 transition-colors ${isActive ? 'text-[#FF5A36]' : 'text-[#6B7280]'}`
              }
            >
              {({ isActive }) => (
                <>
                  <Icon className="h-6 w-6" weight={isActive ? 'fill' : 'regular'} />
                  <span className="text-xs font-medium">{item.label}</span>
                </>
              )}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNav;